import {createAction} from '@reduxjs/toolkit';
import {withPayload} from '../shared/utils/for-redux';

export default {
    refreshData: createAction('app/refreshData', withPayload<'home' | 'init' | void>),
};
